export default __webpack_public_path__ + "d768228fbd47d4b5b5092c5a416db1da.png";